import { Chart } from '@frontend/chart/types';

export const LENDING_OUTBOUND_PACKAGE_VOLUME_HOUR_DAY_HEATMAP_CHART_MOCK_DATA: Chart = {
    series: [
        {
            name: 'Checkouts',
            data: [
                { label: '2026-08-01T09:00:00.000Z', value: 3 },
                { label: '2026-08-01T14:00:00.000Z', value: 7 },
                { label: '2026-08-02T10:00:00.000Z', value: 5 }
            ]
        }
    ]
};
